import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { REGULATED_COLOR_PALETTE } from "../../DataTagConstants";
import RegulatedScatterChart from "./RegulatedScatterChart";
import IconButton from "@mui/material/IconButton";
import "./DataEstateSensitiveCard.scss";
import { FilterIcon } from "../CardWrapper";
import { getRegulatedStats } from "../Overviewadapters";

export default function DataEstateRegulatedCard({
  expanded = false,
  showFilters = false,
}) {
  const [activeFilter, setActiveFilter] = useState(null);
  const [showPopupFilters, setShowPopupFilters] = useState(false);

  // data now comes from /dataEstate/overview (fetched once in DataEstate.jsx)
  const overview = useSelector((state) => state.dataTagReducer.dataEstateOverview);
  const classificationStats = useMemo(() => getRegulatedStats(overview), [overview]);

  const filters = useMemo(() => {
    const set = new Set();

    classificationStats.forEach((item) => {
      item["FileClassificationStats.classificationCombination"]
        .split(",")
        .forEach((c) => set.add(c.trim()));
    });

    return Array.from(set).sort((a, b) => a.localeCompare(b));
  }, [classificationStats]);

  const classificationColors = useMemo(() => {
    return filters.reduce((acc, classification, index) => {
      acc[classification] =
        REGULATED_COLOR_PALETTE[index % REGULATED_COLOR_PALETTE.length];

      return acc;
    }, {});
  }, [filters]);

  const toggleFilter = (type) => {
    setActiveFilter((prev) => (prev === type ? null : type));
  };

  if (!classificationStats.length) {
    return <div className="no-data">No data available</div>;
  }

  // when expanded (popup), the internal header's own toggle controls filters;
  // when not expanded (grid card via CardWrapper), the prop controls filters
  const filtersVisible = expanded ? showPopupFilters : showFilters;

  return (
    <div
      className={`sensitivity-summary-box ${expanded ? "expanded" : "collapsed"}`}
    >
      {expanded && (
        <div className="ss-header">
          <span>Regulated</span>
          <IconButton
            size="small"
            className="regulated-info-icon"
            onClick={() => setShowPopupFilters((prev) => !prev)}
            aria-label="Toggle classification filters"
            title="Regulation filters"
          >
            <FilterIcon />
          </IconButton>
        </div>
      )}

      {filtersVisible && (
        <div className="ss-filters">
          {filters.map((type) => {
            const active = activeFilter === type;
            return (
              <div
                key={type}
                className={`ss-filter ${active ? "active" : ""}`}
                style={{ "--filter-color": classificationColors[type] }}
                onClick={() => toggleFilter(type)}
              >
                {type}
              </div>
            );
          })}
        </div>
      )}

      <RegulatedScatterChart
        data={classificationStats}
        expanded={expanded}
        activeFilter={activeFilter}
        location="dataEstate"
      />
    </div>
  );
}